import { combineReducers } from "redux"
import { reducer as oidcReducer } from "redux-oidc"
import filters from "./filterReducer"
import userDetail from "./userDetailReducer"
import help from "./helpReducer"
import reportSelection from "./reportSelectionReducer"
import {
  activityAndGeneralStats,
  employeeEngagement,
  intelAndInsights,
  peopleBalanceSheet,
  performanceAndProgression,
  customReport,
} from "./dashboards"

const rootReducer = combineReducers({
  oidc: oidcReducer,
  filters,
  userDetail,
  activityAndGeneralStats,
  employeeEngagement,
  intelAndInsights,
  peopleBalanceSheet,
  performanceAndProgression,
  customReport,
  help,
  reportSelection,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/state/reducers/index.js